import React, { Component } from 'react';
import { Team } from 'src/mundial/requests/interfaces';
import Utils from 'src/utils/Utils';
import ApiMundial from '../../requests/api';
import TeamCard from '../TeamCard';
import './_styles.scss';

interface IProps {
}

interface IState {
  teams: Team[];
}

export default class Teams extends Component<IProps, IState> {
    constructor(props: Readonly<IProps>) {
        super(props);
        this.state = {
            teams: []
        }
    }

    async componentDidMount() {
        const teams = await ApiMundial.getAllTeams();
        this.setState({ teams });
    }

    componentDidUpdate() {
        Utils.setInitialFocus(".ribbon-categories.mundial a:nth-child(4)");
    }

    render() {
        return (
            <div className="container-teams">
                {this.state.teams.map((team, index) => 
                    <TeamCard 
                        key={team.id}
                        team={team} 
                        upFocus={Math.floor(index / 6) > 0 ? `#row-${Math.floor(index / 6) - 1}-col-${index % 6}` : undefined}
                        leftFocus={index % 6 === 0 ? '': undefined} 
                        rightFocus={index % 6 === 5 ? '': undefined} 
                        id={`row-${Math.floor(index / 6)}-col-${index % 6}`}
                        row={Math.floor(index / 6)}
                        parentComponent={"teams"}
                        />                  
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/mundial/Home/Teams/index.tsx